import React from "react";
import "./Hero.css";

const Hero = ({ scrollToSection }) => {
  return (
    <section className="hero" id="home">
      <div className="hero-overlay" />

      <div className="hero-content">
        <p className="hero-eyebrow">MOBILE CAR DETAILING</p>

        <h1 className="hero-title">
          <span className="gold">Premium Detailing</span>
          <span className="white">Without the Waste</span>
        </h1>

        <p className="hero-subtitle">
          Smart, sustainable mobile detailing with waterless options,
          eco-rewards, weather-smart scheduling — and a future powered by
          renewable energy.
        </p>

        <p className="hero-location">📍 Chelmsford, Essex, UK</p>

        <div className="hero-buttons">
          <button
            className="btn-primary"
            onClick={() => scrollToSection("booking")}
          >
            📞 Book Now
          </button>

          <button
            className="btn-outline"
            onClick={() => scrollToSection("services")}
          >
            View Services
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
